import dayjs from 'dayjs';

export interface IVectoriserChatQueryRequest {
  case_id: string;
  query: string;
  advisor_id: string;
  session_id?: string;
}

export interface ICharQueryDisplayItems {
  role: string;
  content: string;
}

export interface IVectoriserChatQueryResponse {
  session_id: string;
  response: string;
  display_request: ICharQueryDisplayItems[];
  session_name: string;
}

export type TopicType =
  | 'PersonalDetails'
  | 'Income'
  | 'Expenditure'
  | 'Assets'
  | 'Liabilities'
  | 'HealthCondition'
  | 'InsuranceNBenefits'
  | 'Experience'
  | 'Beneficiaries'
  | 'FinancialPlanning'
  | 'ProtectionSolution'
  | 'InvestmentSolution'
  | 'Summary';

export interface IViewTranscriptRequest {
  caseID?: string;
  transcriptId?: string;
  topicType?: TopicType;
}

export interface ICoversationTextType {
  teamsSpeaker: string;
  text: string;
  textSpeaker: string;
}

export interface IViewTranscriptConversation {
  conversationID: string;
  conversationTimestamp: string;
  conversationText: ICoversationTextType[];
}

export interface IViewTranscriptTopics {
  id: string;
  status: string;
  createdAt: dayjs.ConfigType;
  updatedAt: dayjs.ConfigType;
  advisorID: string;
  prospectiveRetailUserID: string;
  transcriptionID: string;
  caseID: string;
  topicType: TopicType;
  topicSummary: string;
  topicID: string;
  topicStartTime: string;
  topicEndTime: string;
  conversations: IViewTranscriptConversation[];
}

export interface IViewTranscriptResponse {
  resp: IViewTranscriptTopics[];
}

export const TopicTypeLables: Record<TopicType, string> = {
  PersonalDetails: 'Personal Details',
  HealthCondition: 'Health Details',
  InsuranceNBenefits: 'Benefits and Insurance',
  Beneficiaries: 'Nominees',
  Expenditure: 'Expenditures',
  Assets: 'Assets',
  Liabilities: 'Liabilities',
  Summary: 'Summary And Notes',
  Experience: 'Experience',
  InvestmentSolution: 'Investment Solution',
  ProtectionSolution: 'Protection Solution',
  Income: 'Income',
  FinancialPlanning: 'Financial Planning',
};

export interface IViewByIDTranscriptRequest {
  transcriptID?: string;
  transcriptId?: string;
}
export interface IViewByIDTranscriptResponse {
  id: string;
  status: string;
  createdAt: dayjs.ConfigType;
  updatedAt: dayjs.ConfigType;
  advisorID: string;
  caseID: string;
  advisorUserID: string;
  retailUserID: string;
  meetingTranscriptTypes: string;
  language: string;
  fileName: string;
  fileS3Path: string;
  version: number;
  audioFile: boolean;
  transcriptS3Path: string;
  transcriptStatus: string;
  failureReason: string;
  meetingID: string;
  taskID: string;
  transcriptDuration: string;
}

export interface IStreamTranscriptByIDRequest {
  transcriptID: string;
}

export interface IUpdateSessionNameRequest {
  session_id: string;
  session_name: string;
}

export interface IDownloadEmailContentRequest {
  ffEmailContentID: string;
}

export interface IDownloadEmailContentResponse {
  fileName: string;
  emailBody: string;
  fileContent: string;
}

export interface IProcessEmailAttachmentRequest {
  attachments: {
    ffEmailContentID: string;
    documentType: string;
  }[];
}

export interface IFFCompletionRequest {
  retail_user_id: string;
  transcript_id: string;
}

export interface IFFCompletionResponse {
  prospectiveRetailUserId: string;
  transcriptId: string;
  percentComplete: number;
  sectionsCompleted: string[];
}
